export interface TimeWindow {
  /** Earliest appointment start (HH:mm) */
  startTime: string;
  /** Latest appointment start (HH:mm) */
  endTime: string;
}

export interface ScheduleDefaults {
  weekdayWindows: TimeWindow[];
  weekendWindows: TimeWindow[];
  /** Travel / clean-up padding on each side of a booking */
  bufferMinutes: number;
  /** Step size when offering start times to customers (typically 15) */
  startIntervalMinutes: number;
  /** Cap on confirmed bookings in a single day (Seamus’s daily limit) */
  maxAppointmentsPerDay: number;
}

export const DEFAULT_SCHEDULE: ScheduleDefaults = {
  weekdayWindows: [{ startTime: '15:00', endTime: '17:00' }],
  weekendWindows: [{ startTime: '10:00', endTime: '14:00' }],
  bufferMinutes: 15,
  startIntervalMinutes: 15,
  maxAppointmentsPerDay: 1,
};
